var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<ninja-grid no-data-text=\"Add a size and link recipes...\" grid-title=\"Recipes and Sizes\" doc-svc=\"vm.docSvc\" list=\"vm.docSvc.doc.sizes\" create-method=\"\" update-method=\"\" delete-method=\"removeSize\" add-toggle=\"vm.openSizesPanel\" details-link-method=\"vm.ninjaGridDetailsLink\" show-details-link=\"true\" fields=\"{size: {input: 'text', header: 'Size', order: 10, width: 20, type: 'string'}, scaleFactor: {input: 'text', header: 'Scale Factor', order: 10, width: 10, type: 'number'}, recipeName: {input: 'text', header: 'Recipe Name', order: 20, width: 55, type: 'string'}}\"></ninja-grid>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/features/production/menuitems/tabs/tab-recipes-sizes.jade
// module id = 203
// module chunks = 0